import { tipsWidget } from 'config'
import React, { Component } from 'react'
import styled from 'styled-components'
import { Grid } from 'react-flexbox-grid'
import { Input, SimpleButton } from '@ubiwherenpm/adene-ui-components'
import Section from 'components/Section'
import Logic from './logic'

import AdultoIcon from 'containers/Profile/images/adulto.component.svg'
import SearchIcon from 'components/Svg/search.svg'
import ArrowIcon from 'components/Svg/arrow.svg'
import OrderIcon from 'components/Svg/order.svg'
import TopResult from 'components/TopResult'
import NoResults from 'components/NoResults'
import Loading from 'components/Loading'
import Simulating from 'components/Simulating'
import Pagination from 'components/Pagination'
import Select from 'components/Select'
import EditPricesModal from 'components/EditPricesModal'

import ResultsList from 'containers/ResultsList'
import Filters from 'containers/Filters'
import SaveProfileModal from 'containers/SaveProfileModal'

export const Orders = [
  { label: 'Ordernar por preço ascendente', value: 'asc' },
  { label: 'Ordernar por preço descendente', value: 'dec' }
]

export const SearchInputOptions = {
  type: 'text',
  placeholder: 'Nome do comercializador… ',
  icon: SearchIcon
}

export const OrderSelectOptions = {
  placeholder: 'Ordernar..',
  items: Orders,
  icon: OrderIcon,
  arrowIcon: ArrowIcon
}

@Logic
export default class Results extends Component {
  state = {
    showAll: false
  }

  componentWillUnmount () {
    if (tipsWidget) {
      tipsWidget.style.cssText = ''
    }

    window.onpopstate = null
  }

  componentWillMount () {
    if (tipsWidget) {
      tipsWidget.style.cssText = ''
    }
  }

  /**
   * Stuff to do on first mount
   */
  componentDidMount () {
    setTimeout(() => {
      const element = document.getElementById('anchor')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }, 100)

    window.onpopstate = (e) => {
      e.preventDefault()
      this.props.router.push('/')
    }
  }

  toggleFilters = () => {
    const { filtering } = this.props
    if (filtering) {
      this.actions.closeFiltering()
    } else {
      this.actions.openFiltering()
    }
  }

  render () {
    const {
      simulation,
      loadingSugested,
      sugestions,
      simulating,
      router,
      currentPage,
      filtering,
      ordering,
      finished,
      translations,
      showSaveProfileModal,
      showEditPricesModal,
      pricesForm,
      settings,
      startFilters,
      simulatingPatch,
      iframed,
      userProfile
    } = this.props

    const {
      simulationCode
    } = this.props.values

    const { showAll } = this.state

    const {
      changePage,
      search,
      saveProfile,
      toggleSaveProfileModal,
      toggleEditPricesModal,
      editPrices,
      changePrices,
      updatePrices,
      updateProfile,
      getCurrentUser
    } = this.actions

    const simulationError = (finished && finished.simulationError) ? translations['ERROR_' + (finished.simulationErrorCode + '').toUpperCase()] : null

    const showResults = !loadingSugested && sugestions.results && sugestions.results.length
    const isLoading = loadingSugested
    const showNoResults = !loadingSugested && (!sugestions.results || !sugestions.results.length)
    const bestAnnualBilling = simulation && simulation.results && simulation.results.annualBilling
    const hasSimulation = simulation && simulation.results

    // this
    const isFirstResultNegative = showAll || currentPage > 1 || isLoading ? false // Showing all(ex clicked see more anchor)
      : sugestions && // Has simulation
      sugestions.results &&
      sugestions.results.length &&  // has results
      ordering !== 'dec' &&
      ((bestAnnualBilling - sugestions.results[0].annualBilling) <= 0) // First result anual billing <= 0

    if (tipsWidget && !simulating) {
      tipsWidget.style.cssText = 'display:block!important'
    }

    if (simulating) {
      if (tipsWidget) {
        tipsWidget.style.cssText = ''
      }
      return <Simulating />
    }

    if (simulatingPatch) {
      if (tipsWidget) {
        tipsWidget.style.cssText = ''
      }
      return <Simulating />
    }

    return (
      <Wrapper>
        <Section
          title={`Visualize os resultados da sua simulação`}
          subtitle={`Escolha o tarifário que mais se adequa a si e mude já`}
          noContainer
          style={{ backgroundColor: '#F9F9F9' }}
          id={`results`}
          compact={iframed}
        >
          <ResultsWrapper>
            <Container fluid>
              {filtering &&
              <Filters
                renderClose={() => (
                  <FilterButton close onClick={this.toggleFilters}>
                    Fechar
                  </FilterButton>
                )}
                startFilters={startFilters}
              />
              }
              {!filtering &&
                <TopResult
                  hasSimulation={hasSimulation}
                  error={simulationError}
                  {...simulation.results}
                  simulationCode={simulationCode}
                  router={router}
                  onClickToSave={saveProfile}
                  onClickToChangePrices={editPrices}
                />
              }
              {(showAll || isFirstResultNegative) &&
                <Best>
                  <AdultoIcon />
                  <Message>O seu tarifário é o melhor. <Anchor onClick={() => this.setState({ showAll: !showAll })}>Ver outras alternativas</Anchor></Message>
                </Best>
              }

              {/* Disclaimer to show if there are results */}
              {sugestions.results &&
                <Disclaimer dangerouslySetInnerHTML={{__html: translations.RESULTS_DISCLAIMER }}/>
              }
              {hasSimulation &&
              <Header>
                <SearchInput
                  {...SearchInputOptions}
                  onChange={(e) => search(e.target.value)}
                />

                {!filtering &&
                <FilterButton onClick={this.toggleFilters}>
                  Filtrar
                </FilterButton>
                }

              </Header>
              }
              {hasSimulation && showResults && !isFirstResultNegative &&
              <ResultsList
                userProfile={userProfile}
                results={sugestions.results}
                simulation={simulation.results}
                bestAnnualBilling={bestAnnualBilling}
              />
              }
              {hasSimulation && showNoResults && !isFirstResultNegative && <NoResults />}
              {isLoading && <Loading />}
              {hasSimulation && showResults && !isFirstResultNegative &&
              <Pagination
                count={sugestions.count}
                pageChange={changePage} currentPage={currentPage}
              />}
            </Container>
          </ResultsWrapper>
        </Section>

        {showSaveProfileModal.opened &&
          <SaveProfileModal
            {...showSaveProfileModal}
            onClose={() => toggleSaveProfileModal({ opened: false })}
            toogler={toggleSaveProfileModal}
            updateProfile={updateProfile}
            saveProfile={saveProfile}
            settings={settings}
            getCurrentUser={getCurrentUser}
          />
        }
        {showEditPricesModal.opened && 
          <EditPricesModal
            form={pricesForm}
            onChange={changePrices}
            updatePrices={updatePrices}
            {...simulation.results}
            onClose={() => toggleEditPricesModal({ opened: false })}
            toogler={toggleEditPricesModal}
          />
        }
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  width: 100%;
`

export const ResultsWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #F9F9F9;
  margin-top: 140px;
  padding: 70px 0 20px 0;
`

export const Container = styled(Grid)`
  width: 1200px;
  margin: 0 auto;

  @media(max-width: 1280px) {
    width: 100%;
    box-sizing: border-box;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 40px;
  position: relative;
  z-index: 5;
`

export const SearchInput = styled(Input)`
  width: 250px;

  @media(max-width: 1280px) {
    width: 100%;
    box-sizing: border-box;
  }
`

export const OrderSelect = styled(Select)`
  min-width: 280px;
  margin-left: 10px;
`

const Best = styled.div`
  box-shadow: 0 0 6px 0 rgba(0,0,0,0.1);
  padding: 20px;
  width: 890px;
  margin: 20px auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const Message = styled.span`
  font-weight: bold;
  margin-left: 10px;
`

const Anchor = styled.span`
  cursor: pointer;
  color: #93C13E;
`

const Disclaimer = styled.div`
color: #BABABA;
font-size: 14px;
line-height: 18px;
text-align: center;
display: block;
margin: 10px auto;
margin-top: 40px;
`

const FilterButton = styled(SimpleButton)`
  padding: 14px;
  margin-left: 10px;
  width: 150px;


  ${({ close }) => close && `
  position: absolute;
  right: 0px;
  `}
`



// WEBPACK FOOTER //
// ./src/containers/Results/index.js